<template>
  <div>
    <van-form>
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="金额"
        placeholder="请输入金额"
        :rules="[{ required: true }]"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="供应商"
        placeholder="请输入供应商"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.Date"
        label="购入日期"
        placeholder="请选择"
        @click="showPaymentDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.Date"
        label="税种"
        placeholder="请选择"
        @click="showPaymentDate = true"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="税费金额"
        placeholder="请输入"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="含税总金额"
        placeholder="请输入"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvType"
        label="货币"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="数量"
        placeholder="请输入"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvType"
        label="业务单元"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvType"
        label="业务子单元"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvType"
        label="材料类别"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvType"
        label="详细子类别"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvType"
        label="材料"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
    </van-form>
    <div class="mt10">
      <van-button round block type="primary">提交</van-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        formData: {},
        //============================
        Log: '',
        show: false,
        isshow: false,
        isshow2: false,
        columns: 1,
        customercon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
        currencyCon: {
          data1: [{
            text: '',
            value: ''
          }]
        },
        cafeesCon: {
          data1: [{
            text: '',
            value: ''
          }]
        },

        InvType: '',
        State: '',
        GUID: '',
        DC_GUID: '',
        CostSum: '',
        Remark: '',
        Date: '',
        Amount: '',
        TaxationType: '',
        TaxationAmount: '',
        SumAmount: '',
        Currency: '',
        MaterialNumber: '',
        Business_GUID: '',
        SubBusiness_GUID: '',
        AssetTypes: '',
        SonInvType: '',
        SonNextInvType: '',
        MaterielManage: '',
        RPer: '',
        C_GUID: '',
        state: '',
        AID_Flag: '',
        CostType: '',
        MainUse: '',
      }
    },
    mounted() {
      this.GetCustomer()
      this.getcurrency()
      this.catfees()
    },
    methods: {
      GetCustomer() {
        var custormlog = document.getElementById('custormlog')
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetPayeeJson',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.customerList = res.data.result
          // custormlog.style.display="block"
          this.customercon.data1 = new Array();
          for (var i = 0; i < this.customerList.length; i++) {
            this.customercon.data1.push({"text": this.customerList[i].Name, "value": this.customerList[i].Name})
          }
        })
      },
      getcurrency() {
        var currency = document.getElementById('currency')
        this.$axios.post('/fmsapi/common/GetSearchCurrency').then(res => {
          this.currencyList = res.data.result
          this.currencyCon.data1 = new Array();
          for (var i = 0; i < this.currencyList.length; i++) {
            this.currencyCon.data1.push({"text": this.currencyList[i].Code, "value": this.currencyList[i].Code})
          }

        })
      },
      catfees() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetTaxListType',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId'),
          })
        }).then(res => {
          this.catfeesList = res.data.result
          this.cafeesCon.data1 = new Array();
          for (var i = 0; i < this.catfeesList.length; i++) {
            this.cafeesCon.data1.push({
              "text": this.catfeesList[i].Name,
              "value": this.catfeesList[i].Name,
              'T_GUID': this.catfeesList[i].T_GUID,
              'Rate': this.catfeesList[i].Rate
            })
          }
        })
      },
      close() {
        console.log(123)
        this.show = false
      },
      close1() {
        console.log(123)
        this.isshow = false
      },
      close2() {
        console.log(123)
        this.isshow2 = false
      },
      concus(val) {
        var btn2 = document.getElementById('icon2')
        console.log(val.select1.value)
        this.isshow = false
        btn2.value = val.select1.value
        this.Log = btn2.value
        // console.log(JSON.parse(this.defaultData))
      },
      currycon(val) {
        var btn3 = document.getElementById('btncon2')
        this.isshow2 = false
        btn3.value = val.select1.value
        this.Currency = btn3.value
        // console.log(JSON.parse(this.defaultData))
      },
      catfeesCon(val) {
        var btn = document.getElementById('cafees')
        this.show = false
        btn.value = val.select1.value
        sessionStorage.setItem('T_GUID', val.select1.T_GUID)
        sessionStorage.setItem('catname', val.select1.value)
        sessionStorage.setItem('Rate', val.select1.Rate)
        this.TaxationType = btn.value
        console.log(this.TaxationType)
        if (sessionStorage.getItem('Rate') && this.Amount !== '') {
          var a = sessionStorage.getItem('Rate')
          this.TaxationAmount = parseFloat((this.Amount) / (1 + a / 100) * (a / 100)).toFixed(2)
          this.SumAmount = parseFloat(this.Amount)
          this.Amount = parseFloat(this.SumAmount - this.TaxationAmount).toFixed(2)
        } else {
          this.TaxationType = ''
          alert('请输入金额')
        }
        // console.log(JSON.parse(this.defaultData))
      },
      toCus(val) {
        this.isshow = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      toShow(val) {
        this.show = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      toCurry(val) {
        this.isshow2 = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      pro() {
        this.$router.push({path: '/pro'})
      },
      reg() {
        this.$router.push({path: '/reg'})
      },
      Material() {
        this.$router.push({path: '/material'})
      },
      Mate() {
        this.$router.push({path: '/materialp'})
      },
      Materialpurch() {
        this.$router.push({path: '/mate'})
      },
      submitMate() {
        let parms = JSON.stringify({
          GUID: '',
          DC_GUID: '',
          CostSum: '',
          Remark: '',
          Date: '',
          Amount: '',
          TaxationType: '',
          TaxationAmount: '',
          SumAmount: '',
          MaterialNumber: '',
          Currency: '',
          Business_GUID: '',
          SubBusiness_GUID: '',
          AssetTypes: '',
          MainUse: '',
          MaterielManage: '',
          RPer: '',
          C_GUID: sessionStorage.getItem('companyId'),
          State: '',
          AID_Flag: '',
          CostType: '',
        })
        this.$axios.post('/fmsapi/AIDRecord/UpdateAIDRecord', parms, {
          headers: {
            'Content-Type': 'application/json;'
          }
        }).then(res => {
          alert('提交成功')
        })
      },
      Materia() {
        this.$router.push({path: '/Materia'})
      },
      back() {
        this.$router.push('/home')
      },
      accAdd(arg1, arg2) {
        if (!arg1) {
          arg1 = 0;
        }
        if (!arg2) {
          arg2 = 0;
        }
        arg1 = arg1.toString().replace(/\,/g, "");
        arg2 = arg2.toString().replace(/\,/g, "");

        var r1, r2, m, c;
        try {
          r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
          r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
          var cm = Math.pow(10, c);
          if (r1 > r2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
          } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
          }
        } else {
          arg1 = Number(arg1.toString().replace(".", ""));
          arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
      },
      UpdateAIDRecord() {
        let a = this.accAdd(this.TaxationAmount != '' ? this.TaxationAmount : 0, this.Amount != '' ? this.Amount : 0)
        let parms = JSON.stringify({
          GUID: '',
          DC_GUID: '',
          CostSum: '',
          Remark: '',
          Date: this.selectBirthDate,
          Amount: this.Amount,
          TaxationType: this.TaxationType,
          TaxationAmount: this.TaxationAmount,
          SumAmount: a,
          Currency: this.Currency,
          MaterialNumber: '',
          Business_GUID: '',
          SubBusiness_GUID: '',
          AssetTypes: '',
          SonInvType: '',
          SonNextInvType: '',
          MaterielManage: '',
          RPer: sessionStorage.getItem('Rper'),
          C_GUID: sessionStorage.getItem('companyId'),
          State: '',
          AID_Flag: '',
          CostType: '',
          MainUse: ''
        })
        this.$axios.post('/fmsapi/AIDRecord/UpdateAIDRecord', parms, {
          headers: {
            'Content-Type': 'application/json;'
          }
        }).then(res => {
          alert('提交成功')
        })
      },
    }
  }
</script>
